import React, { useEffect, useRef } from "react";
import {createRoot} from "react-dom/client";
import { f7 } from "framework7-react";
import '../helpers/quickbet.css';
import {useTranslation} from "react-i18next";
import {QuickbetCreateForm} from "../Components/QuickbetCreateForm";

interface CreateTicketModalProps {
    opened: boolean;
    onClose: () => void;
}

export const QuickbetCreateModal: React.FC<CreateTicketModalProps> = ({ opened, onClose }) => {
    const sheet = useRef<any>(null);
    const {t} = useTranslation();
    useEffect(() => {
        if (opened) {
            if (!sheet.current) {
                sheet.current = f7.sheet.create({
                    content: `
                    <div class="sheet-modal sheet-modal-bottom quickbetCreateModal">
                        <div class="toolbar">
                            <div class="toolbar-inner">
                            <div class="left"> </div>
                                <div class="right">
                                    <a class="link sheet-close">${t('btn.close')}</a>
                                </div>
                            </div>
                        </div>
                        <div class="sheet-modal-inner">
                            <div class="page-content">
                                <div class="block" id="form-container"></div>
                            </div>
                        </div>
                    </div>
                    `,
                    swipeToClose: true,
                    closeByBackdropClick: true,
                    on: {
                        closed: onClose,
                    },
                });
            }


            sheet.current.open();

            // Після відкриття Sheet вставляємо компонент QuickbetCreateForm
            const formContainer = document.getElementById("form-container");
            if (formContainer) {
                // Створюємо root для рендеринга компоненту
                const root = createRoot(formContainer);
                root.render(<QuickbetCreateForm />);
            }
        } else {
            sheet.current?.close();
        }

        return () => {
            sheet.current?.destroy();
            sheet.current = null;
        };

    }, [opened]);

    return null;
};
